import { ArrayOps, ObjectOps } from '../lift';
/**
 * Converts this Array of numbers or strings to a Set-like object where values are all truthy.
 */
export function toSet() {
    var arr = this.value(), result = {};
    for (var i = 0; i < arr.length; i++) {
        result[arr[i]] = true;
    }
    return new ObjectOps(result);
}
ArrayOps.prototype.toSet = toSet;
